import React from "react";
import { useSearchParams } from "react-router-dom";
import { Currency } from "../../api/stripe";
import { LangSwitcher } from "../../components/LangSwitcher/LangSwitcher";
import "../../components/LangSwitcher/LangSwitcher.css";
import { CheckoutPanel } from "../../components/Checkout/CheckoutPanel";
import "../../components/Checkout/CheckoutPanel.css";

const SUPPORTED_CURRENCIES: ReadonlyArray<Currency> = [
  "USD", "EUR", "AZN", "BYN", "GEL", "KZT", "KGS", "TRY",
];

/** Standalone /checkout page — kept for direct URL access (bookmarks, retries
 *  from /checkout/cancel, etc). Reads `?curr=KZT` to preselect a currency
 *  (defaults to USD). The actual form lives in <CheckoutPanel>, which is also
 *  reused inside the sidebar opened from the landing page. */
const Checkout: React.FC = () => {
  const [params] = useSearchParams();
  const currParam = params.get("curr")?.toUpperCase();
  const defaultCurrency: Currency =
    currParam && (SUPPORTED_CURRENCIES as ReadonlyArray<string>).includes(currParam)
      ? (currParam as Currency)
      : "USD";

  return (
    <div className="mc-page">
      <div className="mc-page__lang">
        <LangSwitcher />
      </div>
      <div className="mc-page__inner">
        <CheckoutPanel defaultCurrency={defaultCurrency} />
      </div>
    </div>
  );
};

export default Checkout;
